import css from './NotValid.module.scss'
import React from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import { GoodTicketCode } from 'types/tickets'

import { IGoodServiceTicketData, Tap2GOTicketTicketStatus } from 'meta/pages/goodsandservices'
import { Routes } from 'meta/routes'
import { Dates } from 'utils/dates'

import { ButtonRed } from 'components/Actions/Action'
import Img from 'components/Media/Img'
import DataTestId from 'meta/dataTestId'

interface Props {
  data: IGoodServiceTicketData
  showQRCodeModal(show: boolean): void
}

const NotValid: React.FC<Props> = (props) => {
  const { data, showQRCodeModal } = props

  const { t } = useTranslation()

  const isEventEnded = Dates.isAfter(new Date(), new Date(data.validTo_tz))

  const isTicketOutOfTime = data.status == Tap2GOTicketTicketStatus.valid && isEventEnded

  const isTicketInGenerationPhase = data.status == Tap2GOTicketTicketStatus.valid && !data.secret

  const isTicketDrink = data.event.policy.code == GoodTicketCode.drink

  return (
    <div className={css.wrapper}>
      <div className={css.already_used}>
        <div className={css.checkmark}>
          {data.status == Tap2GOTicketTicketStatus.cancelled && <Img src="/goodsandservices/red-cross.svg" />}
          {data.status == Tap2GOTicketTicketStatus.checked && <Img src="/goodsandservices/purple-checkmark.svg" />}
          {isTicketOutOfTime && <Img src="/goodsandservices/warning.svg" />}
          {isTicketInGenerationPhase && <Img src="/goodsandservices/reload.svg" />}
        </div>

        {data.status == Tap2GOTicketTicketStatus.checked && (
          <>
            <div data-testid={DataTestId.bag.ticketStatusChecked} className={css.title}>{t('goodsAndServices:status_checked')}</div>
            <div className={css.time}>
              {Dates.format(
                new Date(data.dateEntry_tz ?? data.event.datetime_tz),
                t('goodsAndServices:status_checked_datetime')
              )}
            </div>
          </>
        )}

        {data.status == Tap2GOTicketTicketStatus.cancelled && (
          <>
            <div data-testid={DataTestId.bag.ticketStatusCancelled} className={classNames(css.title, css.cancelled)}>{t('goodsAndServices:status_cancelled')}</div>
            <div className={css.time}>{t('goodsAndServices:status_cancelled_details')}</div>
          </>
        )}

        {isTicketOutOfTime && (
          <>
            <div className={classNames(css.title, css.outOfTime)}>{t('goodsAndServices:status_outOfTime')}</div>
            <div className={css.time}>{t('goodsAndServices:status_outOfTime_desc')}</div>
          </>
        )}

        {isTicketInGenerationPhase && (
          <>
            <div className={classNames(css.title, css.inGenerationPhase)}>
              {t('goodsAndServices:status_inGenerationPhase')}
            </div>
            <div className={css.time}>{t('goodsAndServices:status_inGenerationPhase_desc')}</div>
          </>
        )}

        {!isTicketInGenerationPhase && (
          <div
            className={css.show_code}
            data-testid={DataTestId.bag.btnQRModal}
            onClick={() => {
              showQRCodeModal(true)
            }}
          >
            {t('goodsAndServices:show_qrcode')}
          </div>
        )}
      </div>

      {!isTicketInGenerationPhase && (
        <div className={css.use_drink}>
          <ButtonRed
            disabled={isEventEnded}
            className={css.use_drink_button}
            onClick={() => {
              window.open(Routes.EventIframe.generatePath({ codeUrl: data.event.codeUrl }), '_blank')
            }}
          >
            {t(isTicketDrink ? 'goodsAndServices:button_buy_drink' : 'goodsAndServices:button_buy_generic')}
          </ButtonRed>
        </div>
      )}

      {isTicketInGenerationPhase && (
        <div className={css.use_drink}>
          <ButtonRed
            disabled={isEventEnded}
            className={css.use_drink_button}
            onClick={() => {
              window.location.reload()
            }}
          >
            {t('goodsAndServices:status_inGenerationPhase_button')}
          </ButtonRed>
        </div>
      )}
    </div>
  )
}

export default NotValid
